module.exports = __webpack_public_path__ + "static/media/YF81_7.b5a2e7ea.jpg";